import styled from '@emotion/styled';
import { screenSmMax, spacer40 } from '@spotify-internal/encore-web';

const singleColumnBreakpoint = screenSmMax;

export const TwoColumnLayout = styled.div`
  display: grid;
  grid-gap: ${spacer40};
  grid-template-columns: 1fr 1fr;

  @media (max-width: ${singleColumnBreakpoint}) {
    grid-template-columns: 1fr;
  }
`;

// Only make it narrow when it's a two-column layout; typically used to give the
// left column a little bit of breathing room
export const NarrowColumn = styled.div`
  @media (min-width: ${singleColumnBreakpoint}) {
    max-width: 80%;
  }
`;
